export default "__VITE_ASSET__BqIm4a1I__"